import React, { useState, useContext, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { diamondClarity } from "../../utils/diamondData";
import { PriceContext } from "../../context";

const ClarityForm = ({ name }) => {
  const getContext = useContext(PriceContext);
  const { setPricestepData, pricestepData,reportType } = getContext;
  const { clarity } = pricestepData || {};
  const [show, setShow] = useState(false);
  const [defaultClarity, setDefaultClarity] = useState(
    clarity ? clarity : "Select"
  );
  const handleModal = () => {
    if (reportType === "byGia") {
      return;
    }
    setShow(!show);
  };
  const handleSelect = (value, name) => {
    setDefaultClarity(value);
    setPricestepData({ ...pricestepData, [name]: value, fluorescence : pricestepData?.fluorescence ==='' ? 'None' : pricestepData?.fluorescence , polish: "Vg",
      symmetry: "G"});
    setShow(false);
  };

  useEffect(() => {
    setDefaultClarity(clarity ? clarity : "Select");
  } , [clarity]);
  return (
    <>
      <div className="form-wrapper">
        <div
          className={`${reportType ==="byGia"? "disable_input":""} select-section`}
          onClick={handleModal}
          role="presentation"
          style={{
            opacity: `${pricestepData[name] === "" ? "0.5" : "1"}`,
          }}
        >
          <h6>{defaultClarity}</h6>
        </div>
      </div>
      <ClaritySelector
        show={show}
        handleModal={handleModal}
        handleSelect={handleSelect}
        name={name}
      />
    </>
  );
};

export default ClarityForm;

const ClaritySelector = ({ show, handleModal, handleSelect, name }) => {
  return (
    <Modal
      className="pi-input-selector"
      show={show}
      onHide={handleModal}
      backdropClassName="backdrop-input-bg"
      centered
    >
      <Modal.Body>
        <div className="input-option-wrapper">
          {diamondClarity.map((el, i) => (
            <div
              className="pi-option-elem"
              onClick={() => handleSelect(el.code, name)}
              key={i}
            >
              {el.displayName}
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};
